var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuControlExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 459,
    height: 460,
    viewBox: "0 0 459 460",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M293.375 459.333H165.375C49.535 459.333 0.041626 409.84 0.041626 294V166C0.041626 50.16 49.535 0.666687 165.375 0.666687H293.375C409.215 0.666687 458.708 50.16 458.708 166V294C458.708 409.84 409.428 459.333 293.375 459.333ZM165.375 32.6667C67.0283 32.6667 32.0416 67.6534 32.0416 166V294C32.0416 392.347 67.0283 427.333 165.375 427.333H293.375C391.722 427.333 426.708 392.347 426.708 294V166C426.708 67.6534 391.722 32.6667 293.375 32.6667H165.375Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.042 459.333C135.295 459.333 128.042 452.08 128.042 443.333V16.6667C128.042 7.92002 135.295 0.666687 144.042 0.666687C152.788 0.666687 160.042 7.92002 160.042 16.6667V443.333C160.042 452.08 153.002 459.333 144.042 459.333Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M238.951 159.437C243.005 159.437 247.058 160.931 250.258 164.131L304.871 218.744C311.058 224.931 311.058 235.171 304.871 241.357L250.258 295.971C244.071 302.158 233.831 302.158 227.645 295.971C221.458 289.785 221.458 279.545 227.645 273.358L270.738 230.051L227.431 186.744C221.245 180.557 221.245 170.317 227.431 164.131C230.631 160.931 234.685 159.437 238.951 159.437Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuControlExpand);
export default __webpack_public_path__ + "static/media/menu-control-expand.7d2375b4741f7f9221af082a4cfe31e9.svg";
export { ForwardRef as ReactComponent };